// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"4fbd9724","187":"1eba2156","419":"92b71691","563":"76fb3202","942":"8922db1d"}[chunkId] + ".chunk.js";
};